<template>
  <footer class="container-copyright">
    <ul>
      <li
        v-for="(link, index) in externalLinks"
        :key="index"
      >
        <figure>
          <img
            loading="lazy"
            :src="link.image"
            class=""
            :alt="`${link.name} logo`"
          >
          <figcaption>{{ link.name }}</figcaption>
        </figure>
      </li>
    </ul>

    <section>
      <AppLink
        :to="{ name: 'app_privacy_policy'}"
        class="text-secondary hover:underline"
      >
        Privacy Policy
      </AppLink>

      <span>|</span>

      <AppLink
        :to="{ name: 'app_terms_of_use' }"
        class="text-secondary hover:underline"
      >
        Terms of Use
      </AppLink>
    </section>

    <p class="copyright">
      © Copyright 2025 InstaPix (Pty) Ltd. All rights reserved.
      <br>
      Company reg: 2017/09882307
    </p>
  </footer>
</template>

<script setup>
import { AppLink } from '@/components/app';

import {
  MastercardLogo,
  PayfastLogo,
  SecureEftLogo,
  SnapscanLogo,
  VisaLogo,
  ZapperLogo,
} from '@/assets/images/components/app-copyright-info';

const externalLinks = [
  { name: 'VISA', image: MastercardLogo },
  { name: 'PayFast', image: PayfastLogo },
  { name: 'Zapper', image: SecureEftLogo },
  { name: 'Snapscan', image: SnapscanLogo },
  { name: 'Mastercard', image: VisaLogo },
  { name: 'SiD Secure EFT', image: ZapperLogo },
];
</script>
